var _rect, _rect2, _ellipse;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgCashTwo = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 26,
  height: 24,
  fill: "none"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 16.973,
  height: 10,
  x: 2.054,
  y: 5,
  fill: "#fff",
  stroke: "#56893E",
  strokeWidth: 2,
  rx: 3
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 16.973,
  height: 10,
  x: 6.27,
  y: 8,
  fill: "#fff",
  stroke: "#56893E",
  strokeWidth: 2,
  rx: 3
})), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
  cx: 14.757,
  cy: 13,
  fill: "#56893E",
  rx: 3.162,
  ry: 3
})));
export default SvgCashTwo;